/**
 * Utils are standalone useful tools for other packages that consume OTelJS.
 * If they are unused, then Webpack does not bundle them.
 * Utils must not be imported internally by other modules in OTelJS.
 */
import { __spreadArray } from "tslib";
import { HealthQosError } from './Contracts';
import { SuppressNexus } from './SimpleTelemetryLogger';
/**
 * Sends a Health Qos event. See https://aka.ms/asha/docs for documentation on usage and parameters.
 * @param telemetryLogger - The telemetry logger
 * @param tenant - The name and token for the tenant. The name should be something like "Office.SDX.Health"
 */
export function sendHealthQosError(telemetryLogger, tenant, errorName, vetoes, pillar, isIntentional, isInternal, alertOnPillar, isSessionEndingError, inStaging, additionalDataFields) {
    vetoes.forEach(function (veto) {
        telemetryLogger.sendTelemetryEvent({
            eventName: tenant.name + '.Qos.Error.' + errorName,
            eventFlags: {
                diagnosticLevel: 110 /* DiagnosticLevel.RequiredServiceData */
            },
            dataFields: __spreadArray(__spreadArray([], HealthQosError.getFields({
                veto: veto,
                pillar: pillar,
                isIntentional: isIntentional,
                isInternal: isInternal,
                alertOnPillar: alertOnPillar,
                isSessionEndingError: isSessionEndingError,
                inStaging: inStaging
            }), true), (additionalDataFields || []), true),
            telemetryProperties: {
                ariaTenantToken: tenant.token,
                nexusTenantToken: SuppressNexus
            }
        });
    });
}
//# sourceMappingURL=Utils.js.map